import CategoryBadge from '@/components/shared/CategoryBadge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useBankAccounts } from '@/hooks/use-bank-accounts';
import { uiStateActions } from '@/state/ui-state';
import { formatCurrency, formatDate, TransactionType } from '@polybank/shared';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

interface TransactionListProps {
  title?: React.ReactNode;
  transactions: {
    id: string;
    description: string;
    category_id?: string;
    bank_account_id: string;
    transaction_type: TransactionType;
    amount: number;
    currency: string;
    transaction_date: string;
  }[];
}

export function TransactionListCard({
  transactions,
  title,
}: TransactionListProps) {
  const { bankAccountsMap } = useBankAccounts();

  return (
    <>
      <Card>
        {title && (
          <CardHeader>
            <CardTitle>{title}</CardTitle>
          </CardHeader>
        )}
        <CardContent className='p-0'>
          <div className='space-y-0'>
            {transactions.map(
              (
                {
                  id,
                  description,
                  category_id,
                  bank_account_id,
                  transaction_type,
                  amount,
                  currency,
                  transaction_date,
                },
                index
              ) => (
                <div
                  onClick={() => {
                    uiStateActions.setTransactionIdForDetails(id);
                  }}
                  key={id}
                  className={`flex items-center justify-between p-4 hover:bg-muted/50 transition-colors ${
                    index !== transactions.length - 1
                      ? 'border-b border-border'
                      : ''
                  }`}
                >
                  <div className='flex flex-1 items-center gap-3'>
                    <div>
                      <p className='font-medium'>{description}</p>
                      <div className='flex items-center gap-2 mt-2'>
                        <CategoryBadge categoryId={category_id} />
                        <span className='text-xs text-muted-foreground'>
                          {bankAccountsMap[bank_account_id]?.account_name}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className='text-right'>
                    <div className='flex items-center gap-1'>
                      {transaction_type === 'CREDIT' ? (
                        <ArrowUpRight className='w-4 h-4 text-green-600' />
                      ) : (
                        <ArrowDownRight className='w-4 h-4 text-red-600' />
                      )}
                      <span
                        className={`font-medium ${
                          transaction_type === 'CREDIT'
                            ? 'text-green-600'
                            : 'text-foreground'
                        }`}
                      >
                        {transaction_type === 'CREDIT' ? '+' : '-'}
                        {formatCurrency(Math.abs(amount), currency)}
                      </span>
                    </div>
                    <p className='text-xs text-muted-foreground'>
                      {formatDate(transaction_date)}
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
